import React from 'react';

interface TimelineItemProps {
  title: string;
  company: string;
  period: string;
  description: string[];
  technologies?: string[];
  isLeft: boolean;
}

const TimelineItem: React.FC<TimelineItemProps> = ({
  title,
  company,
  period,
  description,
  technologies,
  isLeft
}) => {
  return (
    <div className={`timeline-item ${isLeft ? 'left' : 'right'}`}>
      <div className="timeline-content">
        <div className="timeline-header">
          <h3>{title}</h3>
          <h4>{company}</h4>
          <span className="period">{period}</span>
        </div>
        <div className="timeline-body">
          <ul>
            {description.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          {technologies && (
            <div className="technologies">
              {technologies.map((tech, index) => (
                <span key={index} className="tech-tag">
                  {tech}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TimelineItem;
